module.exports = __webpack_public_path__ + "img/ship-2.7b064ac1.jpg";